import React from 'react';
import { renderToString } from 'react-dom/server';

// eslint-disable-next-line import/no-extraneous-dependencies
import Icon from 'components/atoms/Icon';

import IconName from 'common/src/app/data/enum/IconName';

import { RichTextIcons } from '../../enums/RichTextIcons';

const getIconName = (iconName: string) => {
  const iconNameMap = new Map([
    [RichTextIcons.FIBRE, IconName.FIBRE],
    [RichTextIcons.CALCIUM, IconName.CALCIUM],
    [RichTextIcons.PROTEIN, IconName.PROTEIN],
    [RichTextIcons.SPEED, IconName.SPEED],
    [RichTextIcons.SP, IconName.SP],
    [RichTextIcons.WHOLEGRAIN, IconName.WHOLEGRAIN],
  ]);

  return iconNameMap.get(iconName);
};

// Replaces an icon string (set in the cms) which is encapsulated in a block of text with the equivalent icon using the icon component
// Possible icon strings:
// - ::calcium::
// - ::fibre::
// - ::protein::
// - ::sp::
// - ::speed::
// - ::wholegrain::
// Example text block:
// - <p>Look for the Speed Free Foods symbol ::speed:: across the app, website and books.</p>
export const replaceIconStringWithIconFunction = (text: string, iconSize?: number): string => {
  const iconRegex = new RegExp(Object.values(RichTextIcons).join('|'), 'g');

  const icons = text?.match(iconRegex) || [];

  let replacedText = text;

  if (icons?.length > 0) {
    icons.map(
      iconName =>
        (replacedText = replacedText.replace(
          iconName,
          renderToString(
            <Icon
              name={getIconName(iconName)}
              height={iconSize || 16}
              width={iconSize || 16}
              key={`icon-${iconName}`}
            />,
          ),
        )),
    );
  }

  return replacedText;
};

export default replaceIconStringWithIconFunction;
